<div class="col-xs-12 p-0" *ngIf="user && !newUI">
  <div class="col-xs-12 title"><em class="fas fa-prescription-bottle-alt pr-3"></em><span>Support Ticket</span><a class="fa fa-plus-square-o ml-3 pointer" routerLink="/chats/open-tickets/new" [queryParams]="{ userId: user.id }" target="_blank"></a><a class="fa fa-history ml-3" (click)="openSupportTicketHistory()"></a></div>
  <div class="col-xs-12">
    <label class="col-xs-4">title</label>
    <label class="col-xs-2">created By</label>
    <label class="col-xs-2">completed By</label>
    <label class="col-xs-2">created At</label>
    <label class="col-xs-2">closed At</label>
  </div>
  <div class="col-xs-12 of-auto" style="max-height:185px;">
    <div class="mb-3 col-xs-12 p-0" *ngFor="let ticket of tickets;let i = index;">
      <col-xs-12 class="text-info bold" [ngClass]="{ 'text-danger': ticket.get('status') === apiClientConstant.SupportTicket.Status.Completed }">
        <div class="col-xs-4"><a routerLink="/ticket/{{user.id}}" [queryParams]="{ ticketId: ticket.id }" target="_blank">{{ticket.get('ticketNumber')}} : {{ticket.get('title') || ticket.get('titleLanguageString')?.get('en')}}</a><em class="fas fa-edit pl-3" *ngIf="ticket.get('status') !== apiClientConstant.SupportTicket.Status.Completed" (click)="editTicket(ticket)"></em></div>
        <div class="col-xs-2"><span *ngIf="ticket.get('createdBy')?.get('type')">{{ticket.get('createdBy')?.get('username') || ticket.get('createdBy')?.get('DoctorDisplayName')}}</span></div>
        <div class="col-xs-2"><span *ngIf="ticket.get('completedBy')?.get('type')">{{ticket.get('completedBy')?.get('username') || ticket.get('completedBy')?.get('DoctorDisplayName')}}</span></div>
        <div class="col-xs-2">{{ticket.get("createdAt") | amDateFormat: 'DD MMM YY'}}</div>
        <div class="col-xs-2"><span *ngIf="ticket.get('closedAt')">{{ticket.get("closedAt") | amDateFormat: 'DD MMM YY'}}</span></div>
      </col-xs-12>
    </div>
  </div>
</div>
<div class="col-xs-12 p-0" *ngIf="user && newUI">
  <div class="col-xs-12" class="ticket-container">
    <div class="ticket-header">
      <div class="filter-container">
        <div data-testid="tickets-heading">
          <span class="title" >Tickets</span>
          <span class="title"> ({{ticketsFetchedSoFar}})</span>
        </div>
        <div class="flex gap-12">
          <div>
            <label data-testid="ticket-filter-all" class="custom-checkbox">
              <input 
                type="radio" 
                name="ticketFilter" 
                (change)="toggleFilter('All')"
                [checked]="true"
              />
              <span class="checkmark"></span>
              <span>All</span>
            </label>
          </div> 
          <div>
            <label data-testid="ticket-filter-active" class="custom-checkbox">
              <input 
                type="radio" 
                name="ticketFilter" 
                (change)="toggleFilter('Active')"
                [checked]=""
              />
              <span class="checkmark"></span>
              <span>Active</span>
            </label>
          </div> 
          <div>
            <label data-testid="ticket-filter-closed" class="custom-checkbox">
              <input 
              type="radio" 
              name="ticketFilter" 
              (change)="toggleFilter('Completed')" 
              [checked]="" />
              <span class="checkmark"></span>
              <span>Closed</span>
            </label>
          </div>
          <div>
            <label data-testid="ticket-filter-spam" class="custom-checkbox">
              <input 
              type="radio"
              name="ticketFilter" 
              (change)="toggleFilter('Spam')" 
              [checked]="" />
              <span class="checkmark"></span>
              <span>Spam</span>
            </label>
          </div>
        </div>
      </div>
      <div class="search-container">
        <input type="text" #searchInput class="custom-select-ticket" placeholder="Search by ticket number" (keyup.enter)="searchTicketByTicketNumber($event.target.value)" (input)="onSearchInputChange($event.target.value)" />
        <i class="fa fa-search search-icon" (click)="searchTicketByTicketNumber(searchInput.value)"></i>
      </div>
      <div class="create-ticket">
        <a data-testid="create-ticket" class="underline bold teal" routerLink="/chats/open-tickets/new" [queryParams]="{ userId: user.id }" target="_blank" >create ticket +</a>
      </div>
    </div>
    <div class="ticket-list" *ngIf="tickets">
      <app-ticket *ngFor="let ticket of tickets; let i = index;" 
                  [ticket]="ticket" 
                  [user]="user"
                  [showDuplicateCheckbox]="showDuplicateCheckboxes"
                  [isSelected]="isTicketSelected(ticket.id)"
                  [isDuplicateCheckboxEnabled]="selectedFilter === 'Active'"
                  (selectionChange)="onTicketSelectionChange($event.ticket, $event.selected)">
      </app-ticket>
    </div>
    <div class="ticket-footer">
      <div class="flex justifySB alignC">
        <span *ngIf="!disableViewMore" (click)="fetchTickets()">View More</span>
        <div class="flex gap-12" *ngIf="showDuplicateCheckboxes" style="width: max-content;">
          <button class="btn btn-xs btn-secondary" (click)="cancelDuplicateSelection()">Cancel Selection</button>
          <button class="btn btn-xs btn-primary"
                  (click)="openDuplicateModal()"
                  [disabled]="selectedTickets?.length < 2">
            Mark as Duplicate ({{selectedTickets?.length}})
          </button>
        </div>
        <button class="btn btn-xs btn-secondary summary-btn" (click)="openSummary()">Summary</button>
      </div>
    </div>
  </div>
</div>